// reCAPTCHA Enterprise — the script tag in public/index.html loads grecaptcha.enterprise.
// We just execute against it here; no runtime script injection.

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const waitForGrecaptcha = () => new Promise((resolve, reject) => {
  const start = Date.now();
  const check = () => {
    if (window.grecaptcha && window.grecaptcha.enterprise) {
      resolve();
    } else if (Date.now() - start > 10000) {
      reject(new Error('reCAPTCHA Enterprise failed to load.'));
    } else {
      setTimeout(check, 50);
    }
  };
  check();
});

export const getRecaptchaToken = async (action) => {
  await waitForGrecaptcha();
  return new Promise((resolve, reject) => {
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(SITE_KEY, { action }).then(resolve).catch(reject);
    });
  });
};

export const getRecaptchaSiteKey = () => SITE_KEY;
